import { useState, useMemo } from 'react';

export const useSelectedItem = ({ initialState }: { initialState: string }) => {
  const [appliedItem, setAppliedItem] = useState(initialState.toString());
  const [selectedItem, setSelectedItem] = useState(appliedItem);

  const selectUniqueItem = (id: string) => {
    setSelectedItem(id);
  };

  const selectedCount = selectedItem.length ? 1 : 0;

  const onApplyItem = () => setAppliedItem(selectedItem);

  const updateSelectedItem = () => {
    if (appliedItem !== selectedItem) {
      setSelectedItem(appliedItem);
    }
  };

  const onClear = () => {
    setAppliedItem('');
    setSelectedItem('');
  };

  const appliedSelectionIds = useMemo(() => [appliedItem], [appliedItem]);

  return {
    selectedItem,
    selectItem: selectUniqueItem,
    onClearMap: onClear,
    onApplyMap: onApplyItem,
    selectedCount,
    updateSelectedMap: updateSelectedItem,
    appliedSelectionIds,
  };
};
